import * as React from 'react';

export const Footer = () => (
  <div className="page-section">
    <div className="copyfooter">
      Yes, I've created this site. Using<a>Gatsby</a>and deployed on Netlify. I ❤️ JamStack.
    </div>
  </div>
);